module.exports = __webpack_public_path__ + "pc/img/rec_13.dee326aa.svg";